import type { RootStoreState } from "@store/types";

import type { ICurrencyEnum, OrderPrices } from "@jti/magento";
import type { MagentoCurrencyCode } from "@jti/magento-types";

// FIXME: returned object is not compatible with OrderPrices
export const calculatePrices = (
  prices: RootStoreState["cart"]["prices"]["data"],
  currency: RootStoreState["cart"]["currency"],
  showPricesWithTaxExcluded = false
): OrderPrices | undefined => {
  if (!prices) {
    return;
  }

  return {
    ...prices,

    appliedTaxes: prices.appliedTaxes?.map((tax) => ({
      ...tax,
      amount: {
        ...tax.amount,
        currency: currency.code as MagentoCurrencyCode,
      },
    })),

    subtotal: showPricesWithTaxExcluded ? prices.subtotal : prices.subtotalIncludingTax,

    discounts: prices.discounts?.map((discount) => ({
      ...discount,
      amount: {
        ...discount.amount,
        currency: currency.code as ICurrencyEnum,
      },
    })),

    grandTotal: {
      ...prices.grandTotal,
      currency: currency.code as ICurrencyEnum,
    },

    shipping: prices.shipping
      ? {
          ...prices.shipping,
          currency: currency.code as ICurrencyEnum,
        }
      : undefined,

    estimatedShippingCost: prices.estimatedShippingCost
      ? {
          ...prices.estimatedShippingCost,
          currency: currency.code as ICurrencyEnum,
        }
      : undefined,
  };
};
